import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
if (container) {
  try {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error("Error rendering app:", error);
    // XSS FIX: Use textContent instead of innerHTML to prevent XSS
    const errorDiv = document.createElement('div');
    errorDiv.style.cssText = 'padding: 20px; color: red;';
    const errorTitle = document.createElement('h1');
    errorTitle.textContent = 'Error';
    const errorMsg = document.createElement('pre');
    errorMsg.textContent = error.message || 'Unknown error occurred';
    errorDiv.appendChild(errorTitle);
    errorDiv.appendChild(errorMsg);
    container.appendChild(errorDiv);
  }
} else {
  console.error("Root element not found!");
}
